module.exports = __webpack_public_path__ + "img/DrillDown.bc21f793.svg";